import { createSelector } from 'reselect';
import name from './name';

export const getSubState = (state) => state[name];

export const createLoadingSelector = (actions) =>
  createSelector([getSubState], (state) =>
    actions.some((action) => state[action]),
  );
